module.exports = __webpack_public_path__ + "assets/new_york@2x.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/new_york@2x.jpg
 ** module id = 229
 ** module chunks = 1
 **/